import { UserApi } from '../../../api';
import { useContainer } from '../../useContainer';

type OptionalCallback = undefined | (() => void);

const useHttpPatchMarkAllNotificationsAsRead = () => {
    const userApi: UserApi = useContainer(UserApi);

    const execPatch = (successCallback: OptionalCallback = undefined) => {
        const { exec, clearCache, abort } = userApi.markAllNotificationsAsRead({
            onSuccess: () => {
                if (successCallback) successCallback();
                clearCache();
                return `Notification successfully make as read!`;
            },
            onError: error => error,
        });
        exec();
        return abort;
    };

    return { execPatch };
};

export default useHttpPatchMarkAllNotificationsAsRead;
